/* eslint-disable prettier/prettier */
import { v4 as uuidv4 } from 'uuid';

class CredoUtils {
  static currentUUID = null;

  static get uuidv4() {
    return uuidv4();
  }

  static async startChecking() {
    await window.credoInstance?.startTracking();
  }

  static async stopChecking() {
    await window.credoInstance?.stopTracking();
  }

  static async collectAsync() {
    await CredoUtils.stopChecking();
    try {
      const currentUUID = CredoUtils.uuidv4;
      await window.credoInstance.stopTrackingAndCompleteAsync(currentUUID);
      CredoUtils.currentUUID = currentUUID;
    } catch {
      CredoUtils.currentUUID = null;
    }
  }
}

export default CredoUtils;
